<template>
  <com-page>
    <com-card>
      <dateSelect @on-date="handleData" @on-export="handleExport"></dateSelect>
    </com-card>
    <com-card class="mt-15px">
      <com-table ref="table" :columns="columns" :api="api"></com-table>
    </com-card>
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils'
import { chargeOrderStatistics } from '@/api/statistics'
import dateSelect from './components/the-time-select'

export default {
  components: { dateSelect },
  data() {
    return {
      api: chargeOrderStatistics,
      columns: [
        {
          label: '日期',
          prop: 'date'
        },
        {
          label: '订单总数',
          prop: 'chargeOrder'
        },
        {
          label: '异常订单数',
          prop: 'errorOrder'
        },
        {
          label: '退单数',
          prop: 'refundOrder'
        },
        {
          label: '订单金额',
          prop: 'chargeAmount'
        },
        {
          label: '退单金额',
          prop: 'refundAmount'
        }
      ],
      query: {}
    }
  },
  methods: {
    handleData(val) {
      this.query = val
      this.$refs.table.search(val)
    },
    async handleExport() {
      try {
        this.$message.info('正在导出请稍后')
        const query = {
          ...this.query,
          pageIndex: 1,
          pageSize: 10000
        }
        const {
          data: { records }
        } = await chargeOrderStatistics(query)
        console.log('data :>> ', records)
        const newArr = []
        records.forEach((item) => {
          const param = {
            日期: item.date,
            订单总数: item.chargeOrder,
            异常订单数: item.errorOrder,
            退单数: item.refundOrder,
            订单金额: item.chargeAmount,
            退单金额: item.refundAmount
          }
          newArr.push(param)
        })
        exportExcel(newArr, '充电订单分析')
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
